import { render, staticRenderFns } from "./AllXwzx.vue?vue&type=template&id=278b3495&scoped=true&"
import script from "./AllXwzx.vue?vue&type=script&lang=js&"
export * from "./AllXwzx.vue?vue&type=script&lang=js&"
import style0 from "./AllXwzx.vue?vue&type=style&index=0&id=278b3495&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278b3495",
  null
  
)

export default component.exports